export default {
  devStoreConfig: false,
  api: {
    default: 'https://tranquil-waters-51040.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: true,
  }
};



// WEBPACK FOOTER //
// ./config/config.client17.js